<template>
  <div class="vx-card" v-if="$store.state.userData.authorizationList.find((f) => f.authorizationId == '23') != null">
    <h1 class="card-bg p-6 text-center mt-4">HARCAMA TÜR YÖNETİMİ</h1>
    <div class="proje_cards pt-6 mb-5">
      <div class="proje_card left mb-5">
        <h2 class="card-bg p-6 mb-3 text-center hoverHeading" @click="showSearchAccountType = !showSearchAccountType">
          <span class="mr-2"><feather-icon icon="SearchIcon" svgClasses="h-6 w-6" /></span><span>Harcama Türü Arama</span>
        </h2>

        <div v-if="showSearchAccountType" class="card-bg p-5">
          <form @submit.prevent="getAccountType()">
            <div class="inputs tFlex tFlex_ai-s gap-1 mb-5">
              <div class="flex-1 gap-3 mb-5">
                <label class="text-sm"><b>Harcama Türü</b></label>
                <v-select @input="getAccountType()" name="accountType" placeholder="Seçiniz" v-model="accountTypeSearch.name" :options="accountTypeList" :clearable="true" :reduce="(accountTypeList) => accountTypeList.name" label="name">
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>
            </div>

            <div class="tFlex tFlex_column tFlex_ai-c tFlex_jc-c mb-3 gap-1">
              <vs-button color="success" class="width-110">Ara</vs-button>
            </div>
          </form>
        </div>
      </div>

      <div class="right mb-5">
        <h2 class="mb-3 card-bg text-center hoverHeading proje_card p-6" @click="showAddAccountType = !showAddAccountType">
          <span class="mr-2"><feather-icon icon="EditIcon" svgClasses="h-6 w-6" /></span><span>Harcama Türü Oluştur</span>
        </h2>
        <div v-if="showAddAccountType" class="card-bg p-5">
          <div class="projects tFlex gap-1 mb-3">
            <div class="left flex-1">
              <div class="mb-5">
                <label class="text-sm"><b>Harcama İsmi</b></label>
                <vs-input type="text" style="width: 100%;" v-model="accountTypeItem.name" placeholder="İsim" />
              </div>
            </div>
            <div class="right flex-1">
              <div class="mb-5">
                <label class="text-sm"><b>Açıklama</b></label>
                <vs-input type="text" style="width: 100%;" v-model="accountTypeItem.description" placeholder="Açıklama" />
              </div>
            </div>
            <div class="right flex-1">
              <div class="mb-5">
                <label class="text-sm"><b>Harcama Türü</b></label>
                <vs-input type="text" style="width: 100%;" v-model="accountTypeItem.accountCorporationType" placeholder="Harcama Türü" />
              </div>
            </div>
          </div>

          <div class="tFlex tFlex_jc-c">
            <vs-button color="success" class="width-220" @click="SaveAccountType(accountTypeItem, 'Insert', '')">Harcama Türü Ekle</vs-button>
          </div>
        </div>
      </div>
    </div>

    <div class="card-bg mb-5 p-5">
      <h2 class="text-center hoverHeading">
        <span class="mr-2"><feather-icon icon="BriefcaseIcon" svgClasses="h-6 w-6" /></span><span>Harcama Türleri</span>
      </h2>

      <div class="vx-row w-full">
        <div class="vx-col w-full mb-5">
          <vs-table search :maxItems="10" :pagination="true" :data="accountTypeList">
            <template slot="thead">
              <vs-th style="width: 10%;">Id</vs-th>
              <vs-th style="width: 30%;">Harcama İsmi</vs-th>
              <vs-th style="width: 10%;">Harcama Türü</vs-th>
              <vs-th style="width: 10%;">İşlemler</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="i" v-for="(tr, i) in data">
                <template v-if="tr.name">
                  <vs-td class="pt-0 pb-1">
                    <vs-input type="text" v-model="tr.id" class="w-full" />
                  </vs-td>
                  <vs-td class="pt-0 pb-1">
                    <vs-input type="text" v-model="tr.name" class="w-full" />
                  </vs-td>

                  <vs-td class="pt-0 pb-1">
                    <vs-input type="text" v-model="tr.accountCorporationType" class="w-full" />
                  </vs-td>

                  <vs-td>
                    <feather-icon icon="TrashIcon" title="Sil" svgClasses="h-6 w-6 hover:text-warning text-danger cursor-pointer" @click.stop="SaveAccountType(tr, 'Delete', 'Harcama türü silinecektir')" />
                    <feather-icon icon="EditIcon" title="Güncelle" svgClasses="h-6 w-6 ml-5 hover:text-warning text-success cursor-pointer" @click.stop="SaveAccountType(tr, 'Update', '')" />
                  </vs-td>
                </template>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";
import vSelect from "vue-select";

// Cell Renderer

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      accountTypeItem: { name: null, description: null, accountCorporationType: null },
      accountTypeList: [],
      accountTypeSearchList: [],
      accountTypeSearch: { name: null },

      showAddAccountType: false,
      showSearchAccountType: false,
      showSearchAccountType: false,
    };
  },

  computed: {},
  methods: {
    getAccountType: async function () {
      this.$vs.loading();
      this.accountTypeList = await repository.postEntity("ParametricScreens/GetAccountType", this.accountTypeSearch).then((r) => r.list);
      this.$vs.loading.close();
    },
    getSearchAccountType: async function () {
      this.$vs.loading();
      this.accountTypeSearchList = await repository.postEntity("ParametricScreens/GetAccountType", this.accountTypeSearch).then((r) => r.list);
      this.$vs.loading.close();
    },

    SaveAccountType: async function (item, operation, messageText) {
      //Insert,Update,Delete
      item.operation = operation;

      let resultConfirm2 = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        text: messageText,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm2.isConfirmed) null;
      else return;

      this.$vs.loading();
      await repository.postEntity("ParametricScreens/SaveAccountType", item);

      this.$vs.loading.close();

      await this.$swal.fire({
        icon: "success",
        title: "İşlem Başarılı",
        //text: "",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Tamam",
        cancelButtonText: "Hayır",
      });

      this.accountTypeItem = {};
      this.accountTypeSearch = {};
      this.getAccountType();
    },
  },

  beforeMount() {},
  beforeUpdate() {},
  mounted() {},
  created: async function () {
    this.$vs.loading();
    await Promise.all([this.getAccountType(), this.getSearchAccountType()]);
    this.$vs.loading.close();
  },
};
</script>

<style lang="scss">
body {
  overflow: auto;
}
.vs-dialog {
  max-width: 1366px !important;
  max-height: 95% !important;
}
</style>
